module.exports = __webpack_public_path__ + "media/images/athletes/1350-4ee8a8a5d68ceb64314741eb3051a878.png";